import { render, staticRenderFns } from "./ImagesPreview.vue?vue&type=template&id=086c0196"
import script from "./ImagesPreview.vue?vue&type=script&lang=js"
export * from "./ImagesPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports